'use client';

import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import Text from '../Text';
import Icon from '../Icon';

function View3DImage({ onView, onClose }) {
  const [openModal, setOpenModal] = useState(null);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [onView]);

  const handleClose = () => {
    setOpenModal(false);
    setTimeout(() => {
      onClose(false);
    }, 200);
  };

  return (
    <div
      className={classNames(
        'w-full h-full bg-black/30 lg:flex lg:justify-center lg:items-center opacity-30 fixed bottom-full left-0 right-0 -z-10 transition-opacity duration-100',
        {
          '!bottom-0 !opacity-100 !z-[500]': openModal,
        },
      )}
    >
      <div
        className={classNames(
          'bg-white w-full lg:w-[1721px] lg:max-w-full 2xl:max-w-[1721px] m-0 lg:m-[100px] p-20 lg:p-[48px] fixed lg:static bottom-[-440px] left-0 right-0 opacity-0 lg:rounded-xl space-y-[20px]  transition-all duration-[400ms] shadow-category-sort-by',
          {
            '!bottom-0 !opacity-100': openModal,
          },
        )}
      >
        <div className="block lg:hidden w-[65px] mx-auto border-b-4 border-himalayan-poppy rounded-[100px]" />
        <div className="flex justify-between gap-[10px]">
          <Text
            type="paragraph"
            className="text-16 text-senate font-encode-sans !font-semibold leading-20 tracking-[0.32px]"
          >
            3D View
          </Text>
          <Icon type="close" onClick={handleClose} className="cursor-pointer" />
        </div>
        <div className="flex items-center gap-[4px]">
          <Icon type="info" />
          <Text
            type="span"
            className="text-12 text-gunmetal font-encode-sans !font-medium leading-14 tracking-[0.24px]"
          >
            Drag around to get a better view of the product.
          </Text>
        </div>
        <div className="bg-lightgrey h-[403px] xl:h-[40vh] 2xl:h-[50vh] flex justify-center items-center">
          3D Image
        </div>
      </div>
    </div>
  );
}

export default View3DImage;
